const usTimeZones = [
  'US/Alaska',
  'US/Arizona',
  'US/Central',
  'US/Eastern',
  'US/Hawaii',
  'US/Mountain',
  'US/Pacific',
  'America/Puerto_Rico',
].map((value) => ({
  label: value,
  value: value,
}));

export default usTimeZones;
